import { render, staticRenderFns } from "./WizardCart.vue?vue&type=template&id=8e824f4c"
import script from "./WizardCart.vue?vue&type=script&lang=ts"
export * from "./WizardCart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports